/** 从 { zh, en, de, ... } 结构取当前语言文案，依次回退 en → zh */
export function resolveText(record, language) {
  if (!record) return "";
  if (typeof record === "string") return record;
  if (record[language]) return record[language];
  // 繁体缺省时回退简体，再回退英文
  if (language === "zh-hant" && record.zh) return record.zh;
  if (language !== "en" && record.en) return record.en;
  if (record.zh) return record.zh;
  const first = Object.values(record).find(Boolean);
  return first || "";
}

/** 轮播图等仅提供 zh/en 资源时的图片选择 */
export function resolveImage(images, language) {
  if (!images) return "";
  if (images[language]) return images[language];
  if (language === "zh" || language === "zh-hant") {
    return images.zh || images.en;
  }
  return images.en || images.zh;
}
